<form class="flex flex-col gap-4" [formGroup]="form()">
  <div class="flex gap-4">
    <mat-form-field class="flex-1">
      <mat-label>ACC Claim Number</mat-label>
      <input
        matInput
        formControlName="claimNumber"
        placeholder="Enter ACC Claim Number"
      />
    </mat-form-field>
    <pt-iso-date-selector
      placeholder="Accident Date"
      formControlName="accidentDate"
      class="flex-1"
    />
  </div>

  <span class="font-bold opacity-80">Patient Details</span>

  <div formGroupName="patientDetails" class="flex flex-col">
    <div class="flex gap-4">
      <mat-form-field>
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Middle Name</mat-label>
        <input matInput formControlName="middleName" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="surname" />
      </mat-form-field>
    </div>

    <div class="flex gap-4">
      <pt-iso-date-selector
        placeholder="Date of Birth"
        formControlName="dateOfBirth"
        class="flex-1"
      />
      <mat-form-field class="flex-1">
        <mat-label>National Health Index Number</mat-label>
        <input matInput formControlName="nhi" />
      </mat-form-field>
    </div>
  </div>

  <span class="font-bold opacity-80">Provider Details</span>

  <div formGroupName="providerDetails" class="flex flex-col">
    <div class="flex gap-4">
      <mat-form-field class="flex-1">
        <mat-label>Provider ID</mat-label>
        <input matInput formControlName="providerId" />
      </mat-form-field>
      <mat-form-field class="flex-1">
        <mat-label>Facility ID</mat-label>
        <input matInput formControlName="facilityId" />
      </mat-form-field>
    </div>

    <div class="flex gap-4">
      <mat-form-field class="flex-1">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" />
      </mat-form-field>
      <mat-form-field class="flex-1">
        <mat-label>Middle Name</mat-label>
        <input matInput formControlName="middleName" />
      </mat-form-field>
      <mat-form-field class="flex-1">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="surname" />
      </mat-form-field>
    </div>
  </div>
</form>
